let headerVue;
document.addEventListener('DOMContentLoaded', function(e) {
    headerVue = Vue.createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                q: '',
                showHeaderBar: true,
                showSearchForm: false,
                activeSubmenu: null,
                showMobileMenu: false,
                hideSiteHeader: false
            }
        },
        mounted() {
            this.checkMobileMenuPosition()
            const this_obj = this;

            //-- open cart drawer on first load
            const urlSearchParams = new URLSearchParams(window.location.search);
            const param = urlSearchParams.get('drawer');
            if(param == 'true') {
                this_obj.showHeaderCart();
            }

            //-- link back mobile clicked
            const mobile_menu_wrapper = document.querySelector('.mobile-menu-wrapper');
            mobile_menu_wrapper.addEventListener('click', function(event){
                if(event.target.closest('#link-back-mobile')) {
                    event.preventDefault();
                    this_obj.hideMobileMenuDrop(event);
                }

                return false;
            });

            //-- page overlay clicked
            const page_overlay = document.querySelector('.header-overlay');
            page_overlay.addEventListener('click', function(event){
                if(window.innerWidth < 1024) {
                    this_obj.toggleMobileMenu();
                }
                this_obj.showSearchForm = false;
            });

            //-- page overlay global clicked
            const page_overlay_global = document.querySelector('.page-overlay.header-cart-overlay');
            page_overlay_global.addEventListener('click', function(event){
                this_obj.showSearchForm = false;
            });

            //-- header search overlay clicked
            const headerSearchOverlay = document.querySelector('.page-overlay.header-search-overlay');
            if(headerSearchOverlay != null) {
                headerSearchOverlay.addEventListener('click', function(e){
                    this_obj.hideDropdown();
                });
            }

            //-- set top position
            const delay = setTimeout(() => {
                this_obj.setTopPosition();
                clearTimeout(delay);
            }, 500);
            
            window.addEventListener('resize', function(){
                this_obj.setTopPosition();
            });
            window.addEventListener('scroll', function(){
                this_obj.setTopPosition();
            });


            //-- search view all clicked & hide dropdown
            document.addEventListener('click', function(e){
                if(e.target.classList.contains('search-view-all')){
                    e.preventDefault();
                    this_obj.clickViewAll();
                }

                const keyword_item = e.target.closest('.keyword-item');
                if(keyword_item != null) {
                    this_obj.q = keyword_item.textContent.trim();
                    this_obj.goSearch();
                }

                if(!e.target.closest('.desktop-menu-wrapper')) {
                    this_obj.hideDropdown();
                }

                if(!e.target.closest('.header-right .header-desktop-search-form') && !e.target.closest('.header-search-dropdown-desktop') && !e.target.closest('.search-sticky') && !e.target.closest('.header-desktop-search')) {
                    this_obj.showSearchForm = false;
                }
            });

            /* set dropdown height */
            const desktop_submenus = document.querySelectorAll('.desktop-submenu');
            desktop_submenus.forEach(function(desktop_submenu) {
                const currentParentHeight = desktop_submenu.offsetHeight;
                const submenu_2s = desktop_submenu.querySelectorAll('.submenu-2');
                const featured_columns = desktop_submenu.querySelectorAll('.featured-column');

                let maxSubmenuHeight = 0;

                submenu_2s.forEach(function(submenu_2) {
                    const height = submenu_2.offsetHeight;
                    if (height > maxSubmenuHeight) {
                        maxSubmenuHeight = height;
                    }
                });

                featured_columns.forEach(function(featured_column) {
                    const height = featured_column.offsetHeight;
                    if (height > maxSubmenuHeight) {
                        maxSubmenuHeight = height;
                    }
                });

                // Only update parent height if a submenu_2 is taller
                if (maxSubmenuHeight > currentParentHeight) {
                    desktop_submenu.style.height = `${maxSubmenuHeight}px`;
                }
            });

            // Run on page load
            window.addEventListener('DOMContentLoaded', this.checkHeaderOffset);

            // Optionally, run on scroll if header might move
            window.addEventListener('scroll', this.checkHeaderOffset);
        },
        methods: {
            checkHeaderOffset() {
                const header = document.getElementById('header-con');
                if (!header) return;

                const rect = header.getBoundingClientRect();
  
                // Check if the top of the header is at or above the top of the viewport
                if (rect.top <= 0) {
                    header.classList.add('scrolled-down');
                } else {
                    header.classList.remove('scrolled-down');
                }
            },
            setTopPosition() {
                //-- set menu dropdown top position
                const mobileDropdownMenu = document.querySelector('#header-con .menu-dropdown-mobile-wrapper');
                const headerMenuHeight = document.querySelector('.site-header .header-con-outer').offsetHeight;
                const overlaySearch = document.querySelector('.header-search-overlay');
                const headerDesktopSearch = document.querySelector('.header-desktop-search');
                const search_result_wrapper = document.querySelector('.sm-search-result');
                const header_desktop_search_form = document.querySelector('.header-desktop-search-form').offsetHeight;
                const popupCart = document.querySelector('#popup-cart');
                
                let topNavHeight = 0;
                if(document.querySelector('#shopify-section-top-nav') != null) {
                    topNavHeight = document.querySelector('#shopify-section-top-nav').offsetHeight;
                }

                if(screen.width < 1024) {
                    const screenHeight = window.innerHeight;

                    if(mobileDropdownMenu != null) {
                        if(window.scrollY < 150) {
                            if($360Shop.is_login) {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight)-50-45)}px`;
                            } else {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight)-50)}px`;
                            }
                        } else {
                            if($360Shop.is_login) {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight)-50-45)}px`;
                            } else {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight)-50)}px`;
                            }
                        }
                    }
                } else {
                    if(popupCart != null) {
                        if(window.scrollY < 150) {
                            popupCart.style.top = `${(topNavHeight+headerMenuHeight)+1}px`;
                        } else {
                            popupCart.style.top = `${(headerMenuHeight)}px`;
                        }
                    }
                }
            },
            toggleCurrencySwitcher(e) {
                e.preventDefault();

                const parent = e.target.closest('.currency-selector');
                if(parent != null) {
                    parent.classList.toggle('active');
                }

                return false;
            },
            changeRightSideContent(e) {
                const elem = e.target;
                const right_side_elem = elem.closest('.menu-dropdown').querySelector('.right-side');
                const submenu_content_title = right_side_elem.querySelector('.submenu-content-title');
                const products_wrapper = right_side_elem.querySelector('.products-wrapper');
                const coll_handle = elem.getAttribute('data-coll-handle');
                const content_title = elem.getAttribute('data-content-title');

                if(coll_handle == '') {
                    submenu_content_title.innerHTML = '';
                    products_wrapper.innerHTML = '';

                    const active_elem = elem.closest('.menu-dropdown').querySelector('.left-side a.active');
                    if(active_elem != null) {
                        active_elem.classList.remove('active');
                    }
                } else {
                    if(!elem.classList.contains('active')) {
                        const active_elem = elem.closest('.menu-dropdown').querySelector('.left-side a.active');
                        if(active_elem != null) {
                            active_elem.classList.remove('active');
                        }

                        elem.classList.add('active');

                        submenu_content_title.innerHTML = content_title;
                        if(content_title == '') {
                            submenu_content_title.classList.remove("mb-28");
                        } else {
                            submenu_content_title.classList.add("mb-28");
                        }

                        products_wrapper.innerHTML = '<p class="p1 pt-32 pb-32 tc w-full show-m"><img width="40" height="40" src="https://cdn.shopify.com/s/files/1/0682/4601/2090/files/200w-ezgif.com-webp-to-gif-converter.gif?v=1732267262" /></p>';

                        axios.get(Shopify.routes.root+`collections/${coll_handle}?view=submenu`)
                        .then(function(response) {
                            const html = document.createRange().createContextualFragment(response.data);
                            products_wrapper.innerHTML = '';
                            products_wrapper.append(html);

                            const delay = setTimeout(() => {
                                $360.lazyLoadInstance.update();
                                
                                clearTimeout(delay);
                            }, 500);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            },
            changeCountry(iso_code,e) {
                e.preventDefault();
                const country_field = e.target.closest('.currency-selector').querySelector('input[name="country_code"]');
                country_field.value = iso_code;
                country_field.closest('form').submit();

                return false;
            },
            setCookie(name, value, days) {
                let expires = "";
                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            },
            closeAnnBar(event) {
                event.preventDefault();
                
                /* set cookie expired in 2 days */
                this.setCookie('hide_ann_bar','true',2);
                this.removeAnnBar();
            },
            removeAnnBar() {
                const site_header = document.querySelector('.site-header');
                const ann_bar = document.querySelector('.header-bar');
                const body = document.querySelector('body');
                const global_content_tm = document.querySelector('.global-content-top-margin');

                if(site_header != null) {
                    if(ann_bar != null) {
                        ann_bar.remove();
                    }

                    body.classList.add('no-bar');

                    $360.headerHeight = site_header.querySelector('.header-con-outer').offsetHeight;
                    if(global_content_tm != null) {
                        global_content_tm.style.marginTop = `-${ann_bar.offsetHeight}px`;
                    }

                    if(site_header.classList.contains('transparent')) {
                        const first_section = document.querySelector('.global-content-top-margin .shopify-section:first-child');
                        if(first_section != null) {
                            first_section.style.marginTop = `-${$360.headerHeight+ann_bar.offsetHeight}px`;
                        }
                    }
                }
            },
            headerSearchHandler(event) {
                const this_obj = this;

                if(event != null) {
                    event.preventDefault();
                }

                /* hide menu on mobile */
                if(screen.width < 1024) {
                    const mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper');
                    if(mobileMenuWrapper != null && mobileMenuWrapper.classList.contains('active')) {
                        this_obj.toggleMobileMenu();
                    }
                }

                const body = document.querySelector('body');
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');
                const page_overlay_global = document.querySelector('.page-overlay.header-search-overlay');
                
                if(!body.classList.contains('no-overflow')) {
                    /*
                    if(filter_bar != null) {
                        filter_bar.classList.remove('zi-6');
                        filter_bar.classList.add('zi-2');
                    }
                    */
                    body.classList.add('no-overflow');
                    if(sticky_elem != null) {
                        sticky_elem.classList.add('zi-2');
                    }

                    this.showSearchForm = !this.showSearchForm;
                    this.$nextTick(() => {
                        const searchTermInput = document.getElementById("search-term");
                        if (searchTermInput != null) {
                            searchTermInput.focus();
                        }
                    });
                } else {
                    // const delay = setTimeout(() => {
                        /*
                        if(filter_bar != null) {
                            filter_bar.classList.remove('zi-2');
                            filter_bar.classList.add('zi-6');
                        }
                        */
                        body.classList.remove('no-overflow');
                        if(sticky_elem != null) {
                            sticky_elem.classList.remove('zi-2');
                        }
                        this.showSearchForm = !this.showSearchForm;
                        
                    //     clearTimeout(delay);
                    // }, 500);
                }

                if(page_overlay_global != null) {
                    page_overlay_global.classList.toggle('active');
                }

                return false;
            },
            handleKeyDown(event) {
                if (event.key === 'Enter') {
                    const searchInput = event.target;
                    console.log('Search input value:', searchInput.value);
                    console.log('Search input trimmed:', searchInput.value.trim());
                    if (searchInput && searchInput.value.trim()) {
                        const searchUrl = `/search?q=${encodeURIComponent(searchInput.value.trim())}&type=product`;
                        console.log('Redirecting to:', searchUrl);
                        window.location.href = searchUrl;
                    }
                }
            },
            clickViewAll() {
                // Try to find the active search input (either desktop or mobile)
                const searchInput = document.querySelector('.header-search-input') || 
                                  document.querySelector('.header-search-mobile-input');
                console.log('ClickViewAll - Found search input:', searchInput);
                console.log('ClickViewAll - Search input value:', searchInput ? searchInput.value : 'No input found');
                if (searchInput && searchInput.value.trim()) {
                    const searchUrl = `/search?q=${encodeURIComponent(searchInput.value.trim())}&type=product`;
                    console.log('ClickViewAll - Redirecting to:', searchUrl);
                    window.location.href = searchUrl;
                }
            },
            debounce(func, wait = 200) {
                let timeout;
              
                return function(...args) {
                  clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    func.apply(this, args);
                  }, wait);   
                };
            },
            goSearch() {
                const debouncedSearch = this.debounce(() => {
                    this.goSearchRequest();
                }, 600);
            
                debouncedSearch();
            },
            async goSearchRequest() {
                try {
                    let resultContainers = document.querySelectorAll('.sm-search-result-target');
                    let data = '';

                    if ($360Shop.enable_insider) {
                        if (this.q.trim() != '') {
                            const req = await $360.getSearchContent('filtered', `${this.q}&type=product`);
                            data = req.data;
                        }
                    } else {
                        // Shopify's predictive search endpoint 422s on an empty q, so an empty
                        // query renders the section via a plain page fetch instead (predictive_search
                        // is nil there, which the section uses to show its Trending fallback).
                        const url = this.q.trim() == ''
                            ? `${window.location.pathname}?section_id=predictive-search`
                            : `${$360Shop.predictive_search_url}?q=${encodeURIComponent(this.q)}&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=hide&section_id=predictive-search`;
                        const res = await fetch(url);
                        const text = await res.text();
                        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
                        data = section ? section.innerHTML : '';
                    }

                    resultContainers.forEach(function(container) {
                        container.innerHTML = data;
                    });
                    $360.lazyLoadInstance.update();
                } catch (error) {
                    console.log(error)
                }
            },
            setStickyElemsToAbove() {
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');

                if(sticky_elem != null) {
                    sticky_elem.classList.remove('zi-2');
                }
            },
            setSimpleDropdownPos() {
                const simple_dropdowns = document.querySelectorAll('.menu-dropdown .simple-dropdown-wrapper');
                simple_dropdowns.forEach(function(dropdown){
                    const parent = dropdown.closest('.menu-dropdown');
                    const li_elem = document.querySelector(`li.parent[data-id="${parent.getAttribute("id")}"]`);

                    if(li_elem != null) {
                        const rect = li_elem.getBoundingClientRect();
                        dropdown.style.left = (rect.left) + 'px';
                    }
                });
            },
            showHeaderCart() {
                $360.showHeaderCart();
            },
            mainNavMouseLeave(e) {
                const delay = setTimeout(() => {
                    const header_links = document.querySelectorAll('.header-nav .header-link');
                    header_links.forEach(function(header_link){
                        header_link.classList.remove('mouseover');
                    });

                    if(window.scrollY < 150 && screen.width > 1023) {
                        if(document.querySelector('#shopify-section-top-nav') != null) {
                            document.querySelector('#shopify-section-top-nav').classList.remove('hover');
                        }
                        document.querySelector('#shopify-section-header').classList.remove('hover');
                    }

                    clearTimeout(delay);
                }, 100);
            },
            showDropdown(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                const this_elem = event.target.closest('a');
                const this_parent = this_elem.closest('li');
                const overlay = document.querySelector('.header-search-overlay');

                const all_dropdown = document.querySelectorAll('.desktop-menu-wrapper li.parent.active');
                all_dropdown.forEach(function(elem){
                    if(this_parent != elem) {
                        elem.classList.remove('active');
                    }
                });

                this_parent.classList.toggle('active');

                if(overlay != null) {
                    if(this_parent.classList.contains('active')) {
                        overlay.classList.add('active');
                    } else {
                        overlay.classList.remove('active');
                    }
                }

                return false;
            },
            hideDropdown() {
                const all_dropdown = document.querySelectorAll('.desktop-menu-wrapper li.parent.active');
                all_dropdown.forEach(function(elem){
                    elem.classList.remove('active');
                });

                const overlay = document.querySelector('.header-search-overlay');
                if(overlay != null) {
                    overlay.classList.remove('active');
                }
            },
            showSubmenu(event) {
                event.preventDefault();
                event.stopImmediatePropagation();

                const this_elem = event.target.closest('a');
                const first_menu = this_elem.closest('li.parent');
                first_menu.classList.remove('active-featured-column');
                
                const this_parent = this_elem.closest('li');
                const this_index = this_parent.getAttribute('data-index');
                const related_featured_column = first_menu.querySelector(`.featured-column[data-submenu-index="${this_index}"]`);
                const submenu = this_parent.querySelector('.submenu-2');

                if(!this_parent.classList.contains('active')) {
                    const all_parent_active_submenu = document.querySelectorAll('.desktop-menu-wrapper li.parent.active-submenu');
                    all_parent_active_submenu.forEach(function(elem){
                        elem.classList.remove('active-submenu');
                    });

                    const all_active_submenu = document.querySelectorAll('.desktop-menu-wrapper li.parent .submenu-2.active');
                    all_active_submenu.forEach(function(elem){
                        elem.closest('li').classList.remove('active');
                        elem.classList.remove('active');
                    });

                    const all_featured_columns = document.querySelectorAll('.desktop-menu-wrapper .featured-column.active');
                    all_featured_columns.forEach(function(elem){
                        elem.classList.remove('active');
                    });
                }

                this_parent.classList.toggle('active');
                if(this_parent.classList.contains('active')) {
                    first_menu.classList.add('active-submenu');
                    submenu.classList.add('active');

                    if(related_featured_column != null) {
                        related_featured_column.classList.add('active');
                        first_menu.classList.add('active-featured-column');
                    }
                } else {
                    first_menu.classList.remove('active-submenu');
                    submenu.classList.remove('active');

                    if(related_featured_column != null) {
                        related_featured_column.classList.remove('active');
                        first_menu.classList.remove('active-featured-column');
                    }
                }

                return false;
            },           
            updateHeaderLinkClasses() {
                const links = document.querySelectorAll('.header-link');
                links.forEach(link => {
                  if (link.classList.contains('active')) {
                    link.classList.remove('non-active');
                  } else {
                    link.classList.add('non-active');
                  }
                });
            },
            mobileMenuAccordion(e) {
                if(window.innerWidth < 1024) {
                    $360.accordionToggle(e)
                }
            },
            toggleMobileMenu(e) {
                const iconMenu = document.querySelector('.header-mobile-menu .icon-menu');
                const iconCloseMenu = document.querySelector('.header-mobile-menu .icon-close-menu');
                const body = document.querySelector('body');
                const page_overlay = document.querySelector('.header-overlay');
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');
                const mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper');
                const topNavMiddle = document.querySelector('.top-nav-middle');

                let topNavHeight = 0;
                if(document.querySelector('#shopify-section-top-nav') != null) {
                    topNavHeight = document.querySelector('#shopify-section-top-nav').offsetHeight;
                }

                let headerConHeight = 0;
                if(document.querySelector('.header-con__inner') != null) {
                    headerConHeight = document.querySelector('.header-con__inner').offsetHeight;
                }

                if(e != null) {
                    e.preventDefault();
                }
                
                const topNav = document.querySelector('#shopify-section-top-nav');
                const header = document.querySelector('#shopify-section-header');
                this.checkMobileMenuPosition()
                const delayShow = setTimeout(() => {
                    this.showMobileMenu = !this.showMobileMenu;
                    if(this.showMobileMenu) {
                        iconMenu.classList.remove('flex');
                        iconMenu.classList.add('hide-m');
                        iconCloseMenu.classList.remove('hide-m');
                        iconCloseMenu.classList.add('flex');
                        body.classList.add('nooverflow');
                        page_overlay.classList.add('show-mobile');

                        if(topNav != null) {
                            header.classList.add('hover');
                            topNav.classList.add('hover');
                        }
    
                        let delay = setTimeout(() => {
                            page_overlay.classList.add('show-fade');
                            $360.lazyLoadInstance.update();
                            
                            clearTimeout(delay);
                        }, 50);
                    } else {
                        iconMenu.classList.remove('hide-m');
                        iconMenu.classList.add('flex');
                        iconCloseMenu.classList.remove('flex');
                        iconCloseMenu.classList.add('hide-m');
                        body.classList.remove('nooverflow');
                        page_overlay.classList.remove('show-fade');

                        if(window.scrollY < 150) {
                            if(topNav != null) {
                                header.classList.remove('hover');
                                topNav.classList.remove('hover');
                            }
                        }
    
                        let delay = setTimeout(() => {
                            page_overlay.classList.remove('show-mobile');
                            if(sticky_elem != null) {
                                sticky_elem.classList.remove('zi-2');
                            }
                            
                            clearTimeout(delay);
                        }, 500);
                    }
                    
                    clearTimeout(delayShow);
                }, 50);

                return false;
            },
            checkMobileMenuPosition(){
                const mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper');
                const topNavMiddle = document.querySelector('.top-nav-middle');
                if(window.scrollY > 0){
                    mobileMenuWrapper.style.top = 0
                } else {
                    mobileMenuWrapper.style.top = topNavMiddle.clientHeight+'px'
                }
            },
            toggleMobileMenuDrop(e) {
                e.preventDefault();

                const parent = e.target.closest('.parent');
                const submenu = parent.querySelector('.mobile-submenu');
                if(submenu) {
                    submenu.classList.toggle('active');
                }

                return false;
            },
            toggleMobileSubmenuDrop(e, index) {
                e.preventDefault();

                const parent = e.target.closest('.parent');
                const submenu = parent.querySelector(`.submenu-2[data-index="${index}"]`);
                if(submenu) {
                    submenu.classList.toggle('active');
                }

                return false;
            },
            hideMobileMenuDrop(e) {
                const parent = e.target.closest('.parent'); 
                const dropdown_el = parent.querySelector('.mobile-menu-dropdown');
                const mobile_menu_wrapper = e.target.closest('.mobile-menu-wrapper');
                mobile_menu_wrapper.classList.remove('nooverflow');

                if(parent.classList.contains('submenu-open')) {
                    dropdown_el.classList.remove('show');

                    const delay = setTimeout(() => {
                        dropdown_el.classList.add('hide-m');
                        parent.classList.remove('submenu-open');     
                        
                        clearTimeout(delay);
                    }, 300);
                }
            }
        }
    });

    headerVue.mount('#header-con');
});

// Global delegated Add-To-Cart handler for grid cards (works with AJAX-loaded content)
if (!window.__gridATCDelegated) {
  window.__gridATCDelegated = true;
  document.addEventListener('click', async function(e){
    var btn = e.target && e.target.closest ? e.target.closest('.js-grid-atc') : null;
    if (!btn) return;
    e.preventDefault();

    try {
      var variantId = Number(btn.getAttribute('data-variant-id'));

      // Purchase limit: the cart already holds the allowed quantity for this
      // variant, so send the shopper to the PDP instead of adding.
      if (await atcPurchaseLimitReached(variantId, btn.getAttribute('data-max-qty-limit'))) {
        var pdpUrl = btn.getAttribute('data-product-url');
        if (pdpUrl) { window.location.href = pdpUrl; }
        return;
      }

      // Read GWP mode from button
      var gwpModeRaw = btn.getAttribute('data-gwp-mode');
      var gwpMode = gwpModeRaw ? Number(gwpModeRaw) : null;
      
      // Read multiple GWP IDs from data-gwp-ids (comma-separated). Fallback to data-gwp-id for backward compatibility
      var gwpRaw = btn.getAttribute('data-gwp-ids') || btn.getAttribute('data-gwp-id') || '';
      var gwpIds = [];
      var theGwpIds = [];
      if (gwpRaw && gwpRaw.trim() !== '') {
        var allGwpIds = gwpRaw
          .split(',')
          .map(function(s){ return Number((s || '').trim()); })
          .filter(function(n){ return !isNaN(n) && n > 0; });
        
        // Apply GWP mode logic
        // Mode 0: Single - take only first GWP
        // Mode 1: Multiple - take all GWPs
        // Mode 2: Auto-add-all - take all GWPs
        // null: Auto-add-all (backward compatibility) - take all GWPs
        if (gwpMode === 0 && allGwpIds.length > 0) {
          theGwpIds = [allGwpIds[0]]; // Only first GWP
        } else {
          theGwpIds = allGwpIds; // All GWPs
        }
        await Promise.all(theGwpIds.map(async (gids)=>{
          let is_available = await fetchProductByVarId(gids)
          console.log('gwp:',is_available)
          if(is_available){
            gwpIds.push(gids) 
          }
        }))
      }

      var mainProduct = { varId: variantId, qty: 1 };
      var dfv = btn.getAttribute('data-direct-from-vendor');
      if (dfv === 'true') {
        var msg = btn.getAttribute('data-direct-message') || '';
        mainProduct.properties = {
          '_directFromVendor': true,
          'Direct From Vendor Message': msg
        };
      }

      // Preorder support (mirror Insider behavior)
      var isPreorder = (btn.getAttribute('data-preorder') === '1' || btn.getAttribute('data-preorder') === 'true');
      var preorderMsg = btn.getAttribute('data-preorder-msg');
      if (isPreorder) {
        if (!mainProduct.properties) { mainProduct.properties = {}; }
        mainProduct.properties['_preorder'] = true;
        if (preorderMsg) { mainProduct.properties['Preorder Message'] = preorderMsg; }
      }

      if (gwpIds.length > 0) {
        // Generate a group ID and tag both items to keep them linked
        var groupId = Date.now() + Math.floor(Math.random() * 100000);
        if (!mainProduct.properties) mainProduct.properties = {};
        mainProduct.properties['_group_id'] = groupId;
        mainProduct.properties['_group_parent'] = true;
        var uniqueGwpIds = gwpIds.filter(function(id, idx, arr){ return arr.indexOf(id) === idx; });
        var products = uniqueGwpIds.map(function(id){
          return { varId: id, qty: 1, properties: { '_isGwp': true, '_group_id': groupId } };
        });
        products.push(mainProduct);
        $360.addToCartMultiple({ products: products, button: btn }, function(){
          if (typeof $360.showPopupCart === 'function') {
            $360.showPopupCart(variantId, 1);
          }
        });
      } else {
        var payload = { qty: 1, variantId: variantId, button: btn };
        if (mainProduct.properties) payload.properties = mainProduct.properties;
        $360.addToCart(payload);
      }
    } catch (err) {
      console.error('[Grid ATC] Failed to process add to cart:', err);
    }
  });
}
// Purchase limit (variant metafield custom.maxquantitylimit) shared by every
// grid/insider Add-To-Cart path. Quantity is summed across cart lines: the same
// variant splits into separate lines when properties differ (_group_id,
// _preorder, ...), so a single-line lookup undercounts what is already there.
async function atcPurchaseLimitReached(variantId, maxQtyLimit) {
  var limit = Number(maxQtyLimit) || 0;
  if (limit <= 0) return false;
  var vid = Number(variantId);
  try {
    var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    var cart = await res.json();
    var inCart = (cart.items || []).reduce(function(sum, item){
      return Number(item.variant_id) === vid ? sum + item.quantity : sum;
    }, 0);
    return inCart >= limit;
  } catch (err) {
    console.warn('[ATC limit] Could not read cart, allowing add:', err);
    return false;
  }
}

// Same metafield, for grids rendered from Insider data where no Liquid ran.
async function fetchVariantMaxQtyLimit(variantId, productHandle) {
  if (!productHandle) return 0;
  var query = `
    query {
      product(handle: "${productHandle}") {
        variants(first: 250) {
          edges {
            node {
              id
              maxQtyLimit: metafield(namespace: "custom", key: "maxquantitylimit") { value }
            }
          }
        }
      }
    }
  `;
  try {
    var response = await axios.post(
      '/api/2026-01/graphql.json',
      { query },
      { headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '5486242070a348ed1676a351a3198880' } }
    );
    var product = response.data && response.data.data && response.data.data.product;
    if (!product) return 0;
    var edge = product.variants.edges.find(function(ed){
      return ed.node.id.split('/').pop() === String(variantId);
    });
    return edge && edge.node.maxQtyLimit ? Number(edge.node.maxQtyLimit.value) || 0 : 0;
  } catch (err) {
    console.warn('[ATC limit] Could not read purchase limit, allowing add:', err);
    return 0;
  }
}

async function fetchProductByVarId(variantId) {
  const query = `
    query {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          id
          title
          availableForSale
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          product {
            title
            description
            handle
            featuredImage {
              url
              altText
            }
          }
        }
      }
    }
  `;
  try {
    const response = await axios.post(
      '/api/2026-01/graphql.json',
      { query },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '5486242070a348ed1676a351a3198880'
        }
      }
    );
    const product = response.data.data.node;
    if (product && product.availableForSale) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error fetching product:", error);
    return false
  }
}	